import { useEffect, useState } from "react";
import { buildCampaignUrl, fetchCampaignAssets } from "../../../services/automapBuyerLaunchApi";
import { trackBuyerLaunchEvent } from "../../../constants/automapBuyerLaunchConstants";
import { LaunchShell } from "./AdminLaunchShared";

export default function AdminLaunchAssetsPage() {
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [builder, setBuilder] = useState({
    basePath: "/carros-usados-medellin",
    utmSource: "google",
    utmMedium: "cpc",
    utmCampaign: "medellin_carros_usados_launch",
    utmContent: "",
    utmTerm: "",
  });
  const [builtUrl, setBuiltUrl] = useState("");

  useEffect(() => {
    fetchCampaignAssets().then(setPayload).finally(() => setLoading(false));
  }, []);

  const generate = async () => {
    const data = await buildCampaignUrl(builder);
    setBuiltUrl(data.url);
    trackBuyerLaunchEvent("launch_campaign_url_created", { url: data.url });
  };

  const copy = (text) => {
    navigator.clipboard?.writeText(text);
    trackBuyerLaunchEvent("launch_asset_copied");
  };

  return (
    <LaunchShell active="assets" title="Campaign assets" description="URLs UTM y copy para canales de launch.">
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {!loading && payload ? (
        <>
          <section className="dealer-state-box">
            <h3>URL builder</h3>
            <div style={{ display: "grid", gap: "0.5rem", maxWidth: 520 }}>
              <input value={builder.basePath} onChange={(e) => setBuilder({ ...builder, basePath: e.target.value })} placeholder="Landing path" />
              <input value={builder.utmSource} onChange={(e) => setBuilder({ ...builder, utmSource: e.target.value })} placeholder="utm_source" />
              <input value={builder.utmMedium} onChange={(e) => setBuilder({ ...builder, utmMedium: e.target.value })} placeholder="utm_medium" />
              <input value={builder.utmCampaign} onChange={(e) => setBuilder({ ...builder, utmCampaign: e.target.value })} placeholder="utm_campaign" />
              <button type="button" className="dealer-portal-btn" onClick={generate}>
                Generar URL
              </button>
              {builtUrl ? (
                <p>
                  {builtUrl}{" "}
                  <button type="button" className="admin-link" onClick={() => copy(builtUrl)}>
                    Copiar
                  </button>
                </p>
              ) : null}
            </div>
            <p className="muted">{payload.qrPlaceholder} · {payload.shortUrlPlaceholder}</p>
          </section>
          <section className="dealer-state-box">
            <h3>Presets</h3>
            {payload.urlPresets?.map((preset) => (
              <div key={preset.key} style={{ marginBottom: "0.75rem" }}>
                <strong>{preset.label}</strong>
                <p>{preset.url}</p>
                <button type="button" className="admin-link" onClick={() => copy(preset.url)}>
                  Copiar
                </button>
              </div>
            ))}
          </section>
          <section className="dealer-state-box">
            <h3>Copy Google Search</h3>
            <ul>
              {payload.copyTemplates?.google_headlines?.map((h) => (
                <li key={h}>{h}</li>
              ))}
            </ul>
            <h4>Meta/TikTok</h4>
            <ul>
              {payload.copyTemplates?.meta_primary?.map((t) => (
                <li key={t}>{t}</li>
              ))}
            </ul>
          </section>
        </>
      ) : null}
    </LaunchShell>
  );
}
